// extracted by mini-css-extract-plugin
export default {"btnpwd":"bdf4967b14"};